<template>
  <div class="foot">
    <div class="footer">
      <!-- <div class="copy" @click="beiantiaozhuan">COPYRIGHT &copy; 2016-2021 PINUC.COM ALLRIGHTS RESERVED 京ICP备16069263</div> -->
      <div class="bottom">
        <div class="item">北京品诺优创科技有限公司</div>
        <div class="item">北京市朝阳区建国路89号华贸商务楼15号楼15层/16层</div>
        <div class="item">邮编：100020</div>
        <div class="item">COPYRIGHT &copy; 2016-2024PINUC.COM ALLRIGHTS RESERVED</div>
        <div class="item copy" @click="beiantiaozhuan">京ICP备16069263号</div>
        <a class="item copy" href="https://beian.mps.gov.cn/#/query/webSearch?code=11010502056342" rel="noreferrer" target="_blank">
          <img src="@/assets/images/pic.png" alt="" class="pic">
          京公网安备11010502056342</a >
		<!-- 北京品诺优创科技有限公司 | 北京市朝阳区建国路89号华贸商务楼15号楼15层/16层  |  邮编：100020 |  COPYRIGHT © 2016-2024PINUC.COM ALLRIGHTS RESERVED | 京ICP备16069263号 -->
      </div>
      <img class="logo-img" src="../assets/images/pinnuologo.png" alt="">
    </div>
    <el-backtop>
      <img class="backtop" src="../assets/images/top.png" alt="">
    </el-backtop>

  </div>
</template>

<script>
export default {
  name: '',
  components: {},
  props: {},
  data() {
    return {
      scrollTop: null, //页面滚动高度
    }
  },
  created() {},
  mounted() {},
  methods: {
    beiantiaozhuan(){
      window.location.href='https://beian.miit.gov.cn/#/Integrated/index';
    },
  },
  filters: {},
  computed: {},
  watch: {},
}
</script>

<style lang="less" scoped>
.foot {
  padding: 0;
  background: #fff;
  position: relative;
  height: 60px;
  border-top: 1px solid  #F3F3F3;;
  .logo {
    width: 100%;
  }
}
.backtop {
  width: 30px;
  height: 30px;
}
.footer{
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 40px;
  padding-right: 55px;
  height: 70px;
  color: #FF710F !important;
  .copy{
    cursor: pointer;
    color: #FF710F !important;
    display: flex;
    align-items: center;
    .pic{
      width: 16px;
      height: 16px;
      margin-right: 4px;
    }
  }
  .logo-img{
    height: 38px;
	  padding-left: 140px;
  }
  .bottom{
    display: flex;
    align-items: center;
    font-size: 14px;
	  font-size: 12px;
    color: #FF710F;
    .item{
      border-right: 1px solid #FF710F;
      padding: 0 8px;
      &:last-child{
        border-right: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pageFooter.vue